export enum AppointmentActionStatus {
  CONFIRMEDSERVICE = 'CONFIRMAT_SERVICE'
}
